import { StepAction } from './stepAction';
import type { LogLevel } from 'sfdc-engine/src/log';
import type { SfdcRecordedStep } from 'clickim/src/common/models/sfdcRecordedStep';
import type { ExtendedSfdcContext } from 'clickim/src/common/playback/stepPlayers/sfdcBaseStepPlayback';

export class SfdcRecordedStepAction extends StepAction<SfdcRecordedStep, ExtendedSfdcContext> {
    override async performAction() {
        const { sfdc } = this.sessionPlayerInit;
        const page = sfdc.sfdcNewSePage(this.driver as any, this.context.sfdcLogHandler || ((level: LogLevel, message: string) => this.context.playback.sfdcAddLog(level, message)));
        page.log.info(`BEGIN STEP '${this.step.getStepPreview?.()}'`);
        try {
            const warnings = await sfdc.sfdcExecuteRecordedStep(page, this.step.recordedData, this.context);
            return { success: true, reason: warnings };
        } catch (err) {
            return {
                success: false,
                reason: err.reason || err.message,
                exception: err,
                shouldRetry: false, // TODO - check this.  Our (bFormat) steps are probably not retryable?
            };
        } finally {
            page.releaseObjects();
        }
    }
}
